//imports
import {
    DEALERS_OVERVIEW_GET_DATA_REQUEST,
    DEALERS_OVERVIEW_GET_DATA_RESULT,
} from 'Redux/actionTypes';

export const dealergetDataRequest = (data) => ({
    type: DEALERS_OVERVIEW_GET_DATA_REQUEST,
    payload: data,
});

export const dealergetDataResult = (result) => ({
    type: DEALERS_OVERVIEW_GET_DATA_RESULT,
    payload: result
});